import { render, staticRenderFns } from "./OrderEditRenderer.vue?vue&type=template&id=ee63c1be&"
import script from "./OrderEditRenderer.vue?vue&type=script&lang=ts&"
export * from "./OrderEditRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports